import React, { useState, useRef } from "react";
import { Modal } from "react-bootstrap";
import FormError from "../../../pages/Auth1/FormError";
import { updateBook } from "../../../Api/Speakers/Books";
import { toast } from "react-toastify";

const EditBookModal = ({ show, onHide, book, reloadBooks, t }) => {
  const fileInputRef = useRef();
  const [formData, setFormData] = useState({
    arabicTitle: book.arabicTitle || "",
    englishTitle: book.englishTitle || "",
    link: book.link || "",
    arabicDescription: book.arabicDescription || "",
    englishDescription: book.englishDescription || "",
    coverImage: null,
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.arabicTitle) newErrors.arabicTitle = t("required");
    if (!formData.englishTitle) newErrors.englishTitle = t("required");
    if (!formData.link) newErrors.link = t("required");
    if (!formData.arabicDescription) newErrors.arabicDescription = t("required");
    if (!formData.englishDescription) newErrors.englishDescription = t("required");
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const payload = new FormData();
    if (formData.coverImage) payload.append("coverPagePath", formData.coverImage);
    payload.append("arabicTitle", formData.arabicTitle);
    payload.append("englishTitle", formData.englishTitle);
    payload.append("link", formData.link);
    payload.append("arabicDescription", formData.arabicDescription);
    payload.append("englishDescription", formData.englishDescription);

    try {
      setLoading(true);
      await updateBook(book.id, payload);
      toast.success(t("book_updated_successfully"));
      reloadBooks();
      onHide();
    } catch (error) {
      const msg = error.detail || error.title || t("book_update_error");
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{t("edit_book")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleUpdate}>
          <div className="row">
            <div className="col-md-4">
              <label className="form-label">{t("cover_image")}</label>
              <div
                className={`drop-zone ${errors.coverImage ? "border border-danger" : ""}`}
                onClick={() => fileInputRef.current.click()}
                style={{ cursor: "pointer" }}
              >
                {formData.coverImage ? (
                  <img
                    src={URL.createObjectURL(formData.coverImage)}
                    alt="preview"
                    style={{ width: "100px", marginTop: "10px" }}
                  />
                ) : (
                  book.coverPagePath && (
                    <img
                      src={book.coverPagePath}
                      alt="current"
                      style={{ width: "100px", marginTop: "10px" }}
                    />
                  )
                )}
                <span className="drop-zone__prompt">
                  <i className="fas fa-upload"></i><br />
                  {t("upload_image")}
                </span>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setFormData({ ...formData, coverImage: e.target.files[0] })}
                  ref={fileInputRef}
                  style={{ display: "none" }}
                />
              </div>
              <FormError errorMessage={errors.coverImage} />
            </div>

            <div className="col-md-8">
              <div className="mb-3">
                <label className="form-label">{t("book_title_ar")}</label>
                <input
                  type="text"
                  className={`form-control ${errors.arabicTitle ? "is-invalid" : ""}`}
                  value={formData.arabicTitle}
                  onChange={(e) => setFormData({ ...formData, arabicTitle: e.target.value })}
                />
                <FormError errorMessage={errors.arabicTitle} />
              </div>

              <div className="mb-3">
                <label className="form-label">{t("book_title_en")}</label>
                <input
                  type="text"
                  className={`form-control ${errors.englishTitle ? "is-invalid" : ""}`}
                  value={formData.englishTitle}
                  onChange={(e) => setFormData({ ...formData, englishTitle: e.target.value })}
                />
                <FormError errorMessage={errors.englishTitle} />
              </div>

              <div className="mb-3">
                <label className="form-label">{t("url")}</label>
                <input
                  type="url"
                  className={`form-control ${errors.link ? "is-invalid" : ""}`}
                  value={formData.link}
                  onChange={(e) => setFormData({ ...formData, link: e.target.value })}
                />
                <FormError errorMessage={errors.link} />
              </div>

              <div className="mb-3">
                <label className="form-label">{t("description_ar")}</label>
                <textarea
                  className="form-control"
                  value={formData.arabicDescription}
                  onChange={(e) =>
                    setFormData({ ...formData, arabicDescription: e.target.value })
                  }
                ></textarea>
                <FormError errorMessage={errors.arabicDescription} />
              </div>

              <div className="mb-3">
                <label className="form-label">{t("description_en")}</label>
                <textarea
                  className="form-control"
                  value={formData.englishDescription}
                  onChange={(e) =>
                    setFormData({ ...formData, englishDescription: e.target.value })
                  }
                ></textarea>
                <FormError errorMessage={errors.englishDescription} />
              </div>
            </div>
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? t("loading") : t("save_changes")}
          </button>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default EditBookModal;
